import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const ModalHeaderWrapper = styled.header`
  display: flex;
  padding: ${Spacing.S24} ${Spacing.S24} ${Spacing.S12} ${Spacing.S32};
`

export const CloseButtonWrapper = styled.div`
  margin-top: -${Spacing.S8};
  margin-left: auto;
`

export const BackButtonWrapper = styled.div`
  margin-right: ${Spacing.S8};
  margin-left: -${Spacing.S8};
`
